import { DateRange } from "@revelate/types";
import { endOfQuarter, startOfQuarter, subQuarters } from "date-fns";

export const defaultDateRange: DateRange = {
  from: startOfQuarter(subQuarters(new Date(), 1)),
  to: endOfQuarter(subQuarters(new Date(), 1)),
};

export const defaultDateRangeValue: string = `${defaultDateRange.from?.toISOString()},${defaultDateRange.to?.toISOString()}`;
